export function dropdown() {
  return {
    open: false,
    trigger() {
      this.open = !this.open
    },
    close() {
      this.open = false
    },
    keyEsc() {
      this.close()
    },
    clickAway() {
      this.close()
    }
  }
}

export function dropdownEmitChanges() {
  return {
    open: false,
    submitted: {},
    selected: {},
    trigger() {
      this.open = !this.open
    },
    close() {
      this.open = false
    },
    keyEsc() {
      if (this.open === true) {
        this.close()
        this.emitChanges()
      }
    },
    clickAway() {
      if (this.open === true) {
        this.close()
        this.emitChanges()
      }
    },
    emitChanges() {
      if (getObjChanges(this.selected, this.submitted) || !this.submitted) {
        window.Livewire.emit('dropdownFormUpdated', this.selected)
        this.submitted = Object.assign({}, this.selected)
      }
    },
    value(val, event) {
      this.selected[event.target.name] = val
    }
  }
}

export function underBlockingAlert() {
  return !!document.querySelector('[data-scan-blocking-alert]');
}

export function modal() {
  return {
    showing: false,
    trigger() {
      if (! this.showing) {
        this.show();
      } else {
        this.dismiss();
      }
    },
    show() {
      this.showing = true;
    },
    dismiss() {
      this.showing = false;
      this.$el.dispatchEvent(new CustomEvent('modal-dismissed', {bubbles: true}));
    },
    keyEsc() {
      this.dismiss()
    },
    // A scanner sheet under an open blocking alert stays open: closing it would drop its pending scans.
    closeUnlessBlocked() {
      if (this.showing && !underBlockingAlert()) this.dismiss();
    },
    isTopSheet() {
      if (underBlockingAlert()) return false;
      const open = Array.from(document.querySelectorAll('[data-scan-stack]')).filter(el => el.__x && el.__x.$data.showing);
      return open[open.length - 1] === this.$el;
    },
    clickAway() {
      this.dismiss()
    }
  }
}

export function table() {
  return {
    endpoint: null,
    trClick(path, event) {
      if (event instanceof MouseEvent) {
        if (event.metaKey || event.altKey) {
          return window.openInNewTab(path)
        }
        if (event.shiftKey) {
          return window.open(path)
        }
        window.location = path;
      }
    }
  }
}

export function vaporFileUpload() {
  return {
    uploadProgress: null,
    change($dispatch) {
      Vapor.store(this.$refs.file.files[0], {
        progress: progress => {
          this.uploadProgress = Math.round(progress * 100);
        }
      }).then(response => {
        $dispatch('file-uploaded', response);
      }).catch(error => {
        $dispatch('file-uploaded-failure', error);
      });
    },
  }
}

export function toaster(lives = {}) {
  return {
    show: false,
    title: '',
    message: '',
    type: 'message',
    timeout: 5000,
    life: 5000,
    shown: 0,
    timer: null,
    trigger(title, message, type) {
      this.show = true;
      this.title = title;
      this.message = message;
      this.type = type ? type : 'message';
      this.life = lives[this.type] || this.timeout;
      this.shown++;
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.hide()
      }, this.life);
    },
    // About the most that fits on one line beside the scanner toast icon at 360px.
    isShort() {
      const text = String(this.message || this.title || '');
      return text.length <= 32 && !text.includes('\n');
    },
    hide() {
      this.show = false;
    },
    // Scanner errors: a refusal that a visible notice states flashes that notice (sc.flashShownRefusal) and clears an
    // older toast, so its text is not read as the reason. Any failure there falls back to the toast.
    scanError(message) {
      let shown = false;
      try {
        shown = window.sc.flashShownRefusal(message);
      } catch (error) {
        console.error(error);
      }
      if (shown) {
        clearTimeout(this.timer);
        return this.hide();
      }
      this.trigger('Oops!', message, 'error');
    },
    listen() {
      this.$el.addEventListener('show-toaster', (event) => {
        this.trigger(event.detail.title, event.detail.message, event.detail.type);
      });
    }
  }
}

export function editInline(startValue) {
  return {
    isEditing: false,
    focus: function () {
      const textInput = this.$refs.textInput;
      textInput.focus();
      textInput.select();
      textInput.value = startValue;
    }
  }
}
